import { c as _c } from "react/compiler-runtime";
import { faroCoreApiClient } from "@api/faro-core-api-client";
import { useCompanyId } from "@context-providers/company-id-provider";
import { useEffect, useState } from "react";
/** A hook that fetches all the Stripe products in the company */
export function useStripeProducts(t0) {
  const $ = _c(8);
  const {
    isEnabled
  } = t0;
  const companyId = useCompanyId();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [stripeProducts, setStripeProducts] = useState(t1);
  const [isLoading, setIsLoading] = useState(isEnabled);
  let t2;
  let t3;
  if ($[1] !== companyId || $[2] !== isEnabled) {
    t2 = () => {
      if (!isEnabled) {
        return;
      }
      const fetchStripeProducts = async function fetchStripeProducts() {
        setIsLoading(true);
        const products = await faroCoreApiClient.company.getStripeProducts({
          companyId
        });
        if (products && products.length > 0) {
          setStripeProducts(products);
        }
        setIsLoading(false);
      };
      fetchStripeProducts();
    };
    t3 = [companyId, isEnabled];
    $[1] = companyId;
    $[2] = isEnabled;
    $[3] = t2;
    $[4] = t3;
  } else {
    t2 = $[3];
    t3 = $[4];
  }
  useEffect(t2, t3);
  let t4;
  if ($[5] !== isLoading || $[6] !== stripeProducts) {
    t4 = {
      stripeProducts,
      isLoading
    };
    $[5] = isLoading;
    $[6] = stripeProducts;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
}